import { Component, Input } from "@angular/core";
import { TaskDescription } from "@apiserver-rest/ponder-tasks-client-base";
import { TaskHistoryTableComponent } from "./task-history-table.component";
import { TaskRunComponent } from "./task-run.component";
import { PonderTasksClient } from "@apiserver-rest/ponder-tasks-client";
import { TaskScheduleTableComponent } from "./task-schedule-table.component";

@Component({
    selector: "task-display",
    imports: [TaskHistoryTableComponent, TaskRunComponent, TaskScheduleTableComponent],
    templateUrl: "./task-display.component.html"
})
export class TaskDisplayComponent {
    @Input({ required: true }) public task!: TaskDescription;

    public constructor(private ponderTasksClient: PonderTasksClient) {

    }
}